import { Capacitor } from "@capacitor/core"
import { Device } from "@capacitor/device"
import { App } from "@capacitor/app"
import { bearerFetcher } from "matsuri-hooks"
import { m2mCleaning_cleanerV4 } from "@/endpoints/m2m-cleaning.cleaner-v4"
import { getCapgoVersionInfo } from "@/utils/capacitorUpdater"

export const saveLoginActivityOnNativeApp = async (accessToken: string) => {
    if (Capacitor.isNativePlatform()) {
        const deviceInfo = await Device.getInfo()
        const appInfo = await App.getInfo()
        const capgoInfo = await getCapgoVersionInfo()

        const endpoint = m2mCleaning_cleanerV4.saveNativeAppActivity
        await bearerFetcher(accessToken, endpoint(), {
            method: endpoint.method,
            body: JSON.stringify({
                os: Capacitor.getPlatform(),
                detailsJson: {
                    deviceInfo: {
                        model: deviceInfo.model,
                        osVersion: deviceInfo.osVersion,
                        iOSVersion: deviceInfo.iOSVersion
                    },
                    appInfo: {
                        version: appInfo.version,
                        build: appInfo.build
                    },
                    capgoInfo: capgoInfo
                }
            })
        })
    }
}
